import type { FolderKind } from './types'

interface FolderScope {
  loadedKind: FolderKind | null
  requestedKind: FolderKind
  loadedCount: number
}

export const isNewFolderScope = ({
  loadedKind,
  requestedKind,
  loadedCount,
}: FolderScope) => loadedKind !== requestedKind || loadedCount === 0
